// extracted by mini-css-extract-plugin
export var addressFields = "_n7-0";
export var animationContainer = "_n7-1";
export var footer = "_n7-2";
export var lineItems = "_n7-3";
export var modalContent = "_n7-4";
export var orderName = "_n7-5";
export var strong = "_n7-6";
export var warning = "_n7-7";